import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { actions } from '../../store'
import Divisions from './Divisions'

const mapStateToProps = state => ({
  division: state.division,
  organization: state.organization
})

const mapDispatchToProps = dispatch => bindActionCreators({
  getDivisions: actions.division.getDivisions,
  getOrganizations: actions.organization.getOrganizations
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Divisions)



// WEBPACK FOOTER //
// ./src/views/Divisions/index.js